import React, { useState } from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const InputBasic = ({ Translation, type='text', ...props }) => {
  const [value, setValue] = useState('')

  const { t } = useTranslation();
  return (
    <TextField
      type={type}
      label={t(Translation)}
      value={value} // Mantiene el valor controlado
      onChange={(e)=> setValue(e.target.value)} // Permite cualquier cambio
      fullWidth
      margin="normal"
      variant="outlined"
      sx={{ bgcolor: "white", borderRadius: 1 }}
      {...props}
    />
  );
};

export default InputBasic;